import ClientAnalyticsProvider from './ClientAnalyticsProvider'

const analytics = ClientAnalyticsProvider

export default analytics
